import { useQueryWithSSRErrors } from "@/shared/hooks";
import { ProductQuery } from "../graphql";
import type {
  ProductQueryType,
  ProductQueryVariablesType,
} from "@/types/graphql/site.generated";

export function useProduct(id?: string, promocodeId?: string | null) {
  const { data, previousData, loading, error, refetch } = useQueryWithSSRErrors<
    ProductQueryType,
    ProductQueryVariablesType
  >(ProductQuery, {
    variables: { id: id as string, promocodeId: promocodeId ?? null },
    skip: !id,
  });

  return {
    // previousData — чтобы карточка не мигала при рефетче с промокодом
    product: data?.product ?? previousData?.product,
    loading,
    error,
    // Рефетч после успешной оплаты: карточка сама переключается на «куплено»
    refetch,
  };
}
